import { IBudgetActionAddEditRequest } from '../../../../model/sge/budget-action/request/budget-action-add-edit-request';
import { IBudgetProgramResponse } from '../../../../model/sge/budget-program/response/budget-program-response';
import { IBudgetUnitResponse } from '../../../../model/sge/budget-unit/response/budget-unit-response';

export type BudgetActionCreateEditState = {
    budgetActionId?: string;
    budgetActionRequest: IBudgetActionAddEditRequest;
    selectedBudgetUnitId?: number;
    budgetUnits: IBudgetUnitResponse[];
    budgetPrograms: IBudgetProgramResponse[];
    showValidationErrors: boolean;
};

export enum ACTION_TYPES {
    setBudgetActionId = 'setBudgetActionId',
    setBudgetActionRequest = 'setBudgetActionRequest',
    updateBudgetActionRequest = 'updateBudgetActionRequest',
    setSelectedBudgetUnitId = 'setSelectedBudgetUnitId',
    setBudgetUnits = 'setBudgetUnits',
    setBudgetPrograms = 'setBudgetPrograms',
    setShowValidationErrors = 'setShowValidationErrors',
}

export const BudgetActionCreateEditReducer = (state: BudgetActionCreateEditState, action: any): BudgetActionCreateEditState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setBudgetActionId:
            return { ...state, budgetActionId: payload };
        case ACTION_TYPES.setBudgetActionRequest:
            return { ...state, budgetActionRequest: payload };
        case ACTION_TYPES.updateBudgetActionRequest:
            return { ...state, budgetActionRequest: { ...state.budgetActionRequest, ...payload } };
        case ACTION_TYPES.setSelectedBudgetUnitId:
            return { ...state, selectedBudgetUnitId: payload };
        case ACTION_TYPES.setBudgetUnits:
            return { ...state, budgetUnits: payload };
        case ACTION_TYPES.setBudgetPrograms:
            return { ...state, budgetPrograms: payload };
        case ACTION_TYPES.setShowValidationErrors:
            return { ...state, showValidationErrors: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
